/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_XlInputs */

const en_val_xl = /** @type {(inputs: Val_XlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XL`)
};

const es_val_xl = /** @type {(inputs: Val_XlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XL`)
};

const fr_val_xl = /** @type {(inputs: Val_XlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XL`)
};

const de_val_xl = /** @type {(inputs: Val_XlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XL`)
};

const ja_val_xl = /** @type {(inputs: Val_XlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XL`)
};

const zh_val_xl = /** @type {(inputs: Val_XlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XL`)
};

const ar_val_xl = /** @type {(inputs: Val_XlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`كبير جداً (XL)`)
};

const id_val_xl = /** @type {(inputs: Val_XlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XL`)
};

const it_val_xl = /** @type {(inputs: Val_XlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XL`)
};

const ru_val_xl = /** @type {(inputs: Val_XlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XL`)
};

const pt_val_xl = /** @type {(inputs: Val_XlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GG (XL)`)
};

const ko_val_xl = /** @type {(inputs: Val_XlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XL`)
};

/**
* | output |
* | --- |
* | "XL" |
*
* @param {Val_XlInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_xl = /** @type {((inputs?: Val_XlInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_XlInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_xl(inputs)
	if (locale === "es") return es_val_xl(inputs)
	if (locale === "fr") return fr_val_xl(inputs)
	if (locale === "de") return de_val_xl(inputs)
	if (locale === "ja") return ja_val_xl(inputs)
	if (locale === "zh") return zh_val_xl(inputs)
	if (locale === "ar") return ar_val_xl(inputs)
	if (locale === "id") return id_val_xl(inputs)
	if (locale === "it") return it_val_xl(inputs)
	if (locale === "ru") return ru_val_xl(inputs)
	if (locale === "pt") return pt_val_xl(inputs)
	return ko_val_xl(inputs)
});